import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createAppKit } from "@reown/appkit/react";
import { mainnet, sepolia, base, gnosis } from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import verifiedLogo from "./assests/header/icon128.png";
import { WagmiProvider } from "wagmi";
import { chainDetails } from "./utils/config";
import { setupMyNearWallet } from "@near-wallet-selector/my-near-wallet";
import { setupSender } from "@near-wallet-selector/sender";
import { setupLedger } from "@near-wallet-selector/ledger";
import { WalletSelectorProvider } from "@near-wallet-selector/react-hook";
import "@near-wallet-selector/modal-ui/styles.css";
import { nearContractProd } from "./utils/constants";
import { ConnectorProvider, useConnector } from "@solana-commerce/connector";

const root = ReactDOM.createRoot(document.getElementById("root"));

const projectId = process.env.REACT_APP_WALLET_CONNECT_ID;

const networks =
  process.env.REACT_APP_NODE_ENV === "production"
    ? [base, mainnet]
    : [sepolia, gnosis];

const metadata = {
  name: "Verified Network",
  description:
    "The decentralized web application for payments, financing and investments on the Verified Network",
  url: window.location.origin, //fix wallet connect metadata warning
  icons: [verifiedLogo],
};

const customRpcUrls =
  process.env.REACT_APP_NODE_ENV === "production"
    ? {
        "eip155:8453": [{ url: chainDetails[8453]?.rpcUrls[0] }],
        "eip155:1": [{ url: chainDetails[1]?.rpcUrls[0] }],
      }
    : {
        "eip155:11155111": [{ url: chainDetails[11155111]?.rpcUrls[0] }],
        "eip155:100": [{ url: chainDetails[100]?.rpcUrls[0] }],
      };

export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  customRpcUrls,
  ssr: true,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  metadata,
  projectId,

  customRpcUrls,

  features: {
    analytics: true,
  },
  //  enableWalletConnect: true,
});

const queryClient = new QueryClient();

const NearConfig = {
  network:
    process.env.REACT_APP_NODE_ENV === "production" ? "mainnet" : "testnet",
  modules: [setupMyNearWallet(), setupLedger(), setupSender()],
  createAccessKeyFor:
    process.env.REACT_APP_NODE_ENV === "production"
      ? "v2.ref-finance.near"
      : "hello.near-examples.testnet",
  theme: "light",
};

root.render(
  <WagmiProvider config={wagmiAdapter.wagmiConfig}>
    <QueryClientProvider client={queryClient}>
      <WalletSelectorProvider config={NearConfig}>
        <ConnectorProvider config={{ autoConnect: false }}>
          <App />
        </ConnectorProvider>
      </WalletSelectorProvider>
    </QueryClientProvider>
  </WagmiProvider>,
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
